const projects = [
    {
        description: { en: "A simple ToDo application to manage tasks.", es: "Una aplicación simple de tareas para gestionar tareas." },
        title: { en: "ToDoApp", es: "Aplicación de Tareas" },
        link: "/projects/todoapp"
    },
    {
        description: { en: "A dashboard to track and analyze physical activity.", es: "Un panel para rastrear y analizar la actividad física." },
        title: { en: "Physical Activity Dashboard", es: "Dashboard de Actividad Física" },
        link: "/projects/physical-activity-dashboard"
    },
    {
        description: { en: "A game character generator to create unique characters.", es: "Un generador de personajes de juego para crear personajes únicos." },
        title: { en: "Game Character Generator", es: "Generador de Personajes de Juego" },
        link: "/projects/game-character-generator"
    }
];

export default projects;
